module.exports = __webpack_public_path__ + "img/chl.8949f9e6.svg";